import React from 'react'
import PropTypes from 'prop-types'
import { Margin } from 'shared/components'

import { TeamDetailsPanel } from './components/teamDetailsPanel'

const TeamViewComponent = ({ teamId }) => (
  <Margin bottom={2}>
    <TeamDetailsPanel teamId={teamId} />
  </Margin>
)

TeamViewComponent.propTypes = {
  teamId: PropTypes.number,
}

export default TeamViewComponent
